import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { getResponseErrors, ResponseError } from '@ui/src';
import { clearIndividualTurnoverFormState } from '../store/slices/volumes-form';
import { useLazyGetCorporateVolumeQuery } from '../store/services';
import VolumesForm from '../../partial/volumes/form';
import { RiskScoreClientTypeEnum } from '../../types';

const CorporateVolumesForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [errorList, setErrorList] = useState('');

  const {
    corporateClientsRisk: {
      volumes: {
        form: { formValues },
      },
    },
  } = useAppSelector((state) => state);

  const { itemId } = useParams();
  const [getVolume, { isLoading, isFetching }] =
    useLazyGetCorporateVolumeQuery();

  const dispatch = useAppDispatch();

  const getVolumeAction = useCallback(async (id: string) => {
    const response = (await getVolume(id)) as { error?: ResponseError };

    if (response?.error) {
      getResponseErrors({
        error: response?.error,
        setErrorList,
      });
    }
  }, []);

  useEffect(() => {
    setPanelIsOpen(true);

    if (itemId) {
      getVolumeAction(itemId);
    }

    return () => {
      dispatch(clearIndividualTurnoverFormState());
    };
  }, [dispatch, itemId]);

  return (
    <VolumesForm
      formValues={formValues}
      isLoading={isLoading || isFetching}
      clientType={RiskScoreClientTypeEnum.CORPORATE}
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      errorList={errorList}
    />
  );
};

export default CorporateVolumesForm;
